
import { createContext, useContext, useState } from "react";

// Create a context for sharing the expanded state across components
interface CollapsibleContextType {
  isOpen: boolean;
  toggleOpen: () => void;
  setOpen: (isOpen: boolean) => void;
}

export const CollapsibleContext = createContext<CollapsibleContextType>({
  isOpen: false,
  toggleOpen: () => {},
  setOpen: () => {},
});

// Provider component to manage the global expanded state
export const CollapsibleProvider: React.FC<{children: React.ReactNode, defaultOpen?: boolean}> = ({ 
  children, 
  defaultOpen = false 
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  
  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const setOpen = (open: boolean) => {
    setIsOpen(open);
  };
  
  return (
    <CollapsibleContext.Provider value={{ isOpen, toggleOpen, setOpen }}>
      {children}
    </CollapsibleContext.Provider>
  );
};

// Hook to use the collapsible context
export const useCollapsible = () => useContext(CollapsibleContext);
